/**
 * PROTOTYPE CONTENT — NOT VERIFIED. Restored verbatim from `design-reference/`.
 * The markets and the figures against them are illustrative, and the split
 * against Samloryx Consultancy is still open in `company/POSITIONING.md`.
 */
export interface Sector {
  name: string
  blurb: string
  /** Types of buyer, separated by ` · `. */
  clients: string
  /** Single headline figure shown on the right. */
  stat: string
}

export const sectors: Sector[] = [
  {
    name: 'Public Infrastructure',
    blurb: 'Municipal roads, bulk water and community services — the work that gets a young contractor graded, trusted and re-appointed.',
    clients: 'Local municipalities · District councils · Water services authorities',
    stat: '1 contract live',
  },
  {
    name: 'Mining & Resources',
    blurb: 'Access roads, plant terraces, sumps and drainage on live operations in Mpumalanga and North West.',
    clients: 'Coal producers · PGM producers · Contract miners',
    stat: '2 awarded',
  },
  {
    name: 'Property Development',
    blurb: 'Bulk earthworks, platforms and internal services for industrial parks and residential schemes.',
    clients: 'Developers · Social housing institutions',
    stat: '2 sites',
  },
  {
    name: 'Industrial & Logistics',
    blurb: 'Hardstandings, yards, warehouse platforms and stormwater for distribution facilities.',
    clients: 'Logistics operators · Industrial landlords',
    stat: '18 000 m²',
  },
  {
    name: 'Energy & Electrical',
    blurb: 'Substation civils, cable trenching and solar mounting — a capability we are actively tendering into.',
    clients: 'IPPs · Industrial clients',
    stat: 'Tendering',
  },
]
